// This file is auto-generated during the build process
export const BUILD_VERSION = "20260625-2";
export const BUILD_DATE = "2026-06-25T09:51:39.634Z";
